import { DetailedLoanCard } from './DetailedLoanCard';
import { useLanguage } from '@/contexts/LanguageContext';
import { Suspense } from 'react';

interface LoanProduct {
  provider: string;
  logo: string;
  loanAmount: string;
  nominalRate: string;
  effectiveRate: string;
  loanTerm: string;
  loanWithoutUC: string;
  responseTime: string;
  paymentSolution: string;
  link: string;
  rating?: number;
  reviewCount?: number;
  lenderBadge?: string;
}

interface VirtualizedProductListProps {
  products: LoanProduct[];
  itemHeight?: number;
  /** Show all items on desktop (>= 1024px), virtualize on mobile/tablet */
  virtualizeOnMobileOnly?: boolean;
}

/**
 * Simple product list component (virtualization temporarily disabled for stability)
 * Renders all products in a responsive grid
 */
export const VirtualizedProductList = ({ 
  products, 
  itemHeight = 420,
  virtualizeOnMobileOnly = true 
}: VirtualizedProductListProps) => {
  const { currentLanguage } = useLanguage();

  // Simple grid rendering for stability
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {products.map((product, idx) => (
        <Suspense
          key={`${product.provider}-${idx}`}
          fallback={
            <div className="h-[420px] bg-muted/30 animate-pulse rounded-lg" />
          }
        >
          <DetailedLoanCard {...product} />
        </Suspense>
      ))}
    </div>
  );
};
